import { Tooltip } from '@chakra-ui/react';
import styles from './StatusCellRenderer.module.css';
import { Box, Text } from '@chakra-ui/react';
import AORStatuses from '../utils/statuses';

const StatusCellRenderer = ({ value, noCircle, statusMessage }) => {
    // Get status configuration, fallback to default if not found
    const statusConfig = AORStatuses[value] || {
        type: 'disabled',
        displayedName: value || 'Unknown',
        toolTip: `Status: ${value}`,
    };

    const tooltipLabel =
        (statusConfig.toolTip ? statusConfig.toolTip : '') +
        (statusMessage ? `: ${statusMessage}` : '');

    const noMessage = !statusMessage && !statusConfig.toolTip;

    const displayName = statusConfig.displayedName;

    return (
        <Tooltip
            hasArrow
            disabled={noMessage}
            maxW="400px"
            width="auto"
            label={!noMessage && tooltipLabel}
            aria-label={statusConfig.toolTip}>
            <Box
                className={`${styles.tag} ${styles[statusConfig.type + 'Tag']}`}
                sx={{
                    display: 'flex',
                    alignItems: noCircle ? 'center' : null,
                    justifyContent: noCircle ? 'center' : null,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}>
                {!noCircle && (
                    <div
                        className={`${styles.circle} ${styles[statusConfig.type + 'Circle']}`}
                    />
                )}
                <Text isTruncated>{displayName}</Text>
            </Box>
        </Tooltip>
    );
};

export default StatusCellRenderer;
